// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#block1 .top-title[data-v-40388347]{margin-top:calc(var(--fs-600)*2);font-weight:700}.event-btn-wrapper button[data-v-40388347]{padding:8px var(--fs-600);border-radius:var(--fs-400);color:#fff;background-color:#03112a;border:unset;transition:all .2s ease-in-out}.event-btn-wrapper button[data-v-40388347]:hover{filter:brightness(1.5)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
